if (!customElements.get('products-toolbar')) {
  class ProductsToolbar extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.filtersComponent = document.querySelector('facet-filters');
      this.filtersColumn = document.querySelector('.main-products-grid__filters');
      this.layoutSwitcher = this.querySelector('.products-toolbar__layout');
      this.compareToggle = document.getElementById('compare-switch');
      this.sortBy = this.querySelector('.products-toolbar__sort');
      this.productsGrid = document.querySelector('.main-products-grid');

      if (this.filtersColumn) {
        this.filterToggle = this.querySelector('.js-toggle-filters');
        this.filterToggle.addEventListener('click', this.toggleFilters.bind(this));
      }

      if (this.layoutSwitcher) {
        this.layoutSwitcher.addEventListener('change', this.handleLayoutChange.bind(this));

        const layout = theme.storageUtil.get('products-layout');
        if (layout && layout === 'list') {
          const toggle = document.getElementById(`${layout}-layout-opt`);
          if (toggle) toggle.click();
          this.handleLayoutChange(null, layout);
        }
      }

      if (this.compareToggle) {
        this.compareToggle.addEventListener('change', this.toggleCompare.bind(this));

        const isChecked = theme.storageUtil.get('compare-toggle', true);
        if (isChecked !== null) {
          this.toggleCompare(null, isChecked, true);
        } else {
          this.toggleCompare(null, this.compareToggle.checked, false);
        }

        setTimeout(() => {
          this.classList.add('transition-ready');
          this.productsGrid.classList.add('transition-ready');
        }, 500);
      } else if (theme.settings.compareToggle === 'none') {
        this.toggleCompare(null, true, false);
      }

      if (!this.filtersComponent && this.sortBy) {
        this.sortBy.addEventListener('change', ProductsToolbar.handleSortByChange);
      }
    }

    toggleCompare(evt, checked = null, persist = true) {
      const isChecked = evt ? evt.target.checked : checked;
      this.productsGrid.dataset.compare = isChecked;

      const compareButton = document.getElementById('compare-drawer-open');
      compareButton.classList.toggle('is-out', !isChecked);

      if (!evt && this.compareToggle) this.compareToggle.checked = isChecked;

      if (persist && !Shopify.designMode) {
        theme.storageUtil.set('compare-toggle', isChecked);
      }

      if (isChecked) {
        const resourcesTag = document.getElementById('compare-resources');
        if (resourcesTag) {
          const resources = JSON.parse(resourcesTag.textContent);
          resources.forEach((resource) => {
            if (resource.type === 'js') {
              const script = document.createElement('script');
              script.src = resource.path;
              document.head.appendChild(script);
            } else if (resource.type === 'css') {
              const link = document.createElement('link');
              link.href = resource.path;
              link.type = 'text/css';
              link.rel = 'stylesheet';
              document.head.appendChild(link);
            }
          });
          resourcesTag.remove();
        }
      }
    }

    toggleFilters() {
      this.filterToggle.classList.toggle('is-active');
      this.filtersOpen = this.filterToggle.classList.contains('is-active');
      this.filterToggle.setAttribute('aria-expanded', this.filtersOpen);

      if (theme.mediaMatches.lg) {
        this.filtersColumn.classList.toggle('lg:js-hidden', !this.filtersOpen);
        const productsList = document.querySelector('.main-products-grid__results > .grid');

        productsList.className = this.filtersOpen
          ? productsList.dataset.filtersOpenClasses
          : productsList.dataset.filtersClosedClasses;
      } else {
        this.filtersComponent.open();
      }
    }

    handleLayoutChange(evt, layout) {
      this.productsGrid.dataset.layout = layout || evt.target.value;
      if (!layout) theme.storageUtil.set('products-layout', evt.target.value);
    }

    static handleSortByChange(evt) {
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.set('sort_by', evt.detail.selectedValue);
      urlObj.hash = 'products-toolbar';
      window.location.href = urlObj.toString();
    }
  }

  customElements.define('products-toolbar', ProductsToolbar);
}

/* FDH finish-collection card variant selection. Keeps product media assignments unchanged. */
(() => {
  const suffixes = ['-cabinet-hardware', '-cabinet-pulls', '-cabinet-knobs'];
  const brandedFinishHandles = {
    'top-knobs-honey-bronze-hardware': 'honey bronze'
  };
  const normalize = (value) => (value || '').toLowerCase().replace(/\s+/g, ' ').trim();

  function getFinishData() {
    const match = window.location.pathname.match(/^\/collections\/([^/?#]+)/i);
    if (!match) return null;

    const handle = normalize(match[1]);
    const brandedFinish = brandedFinishHandles[handle];
    if (brandedFinish) return { handle, finish: brandedFinish };

    const suffix = suffixes.find((item) => handle.endsWith(item));
    if (!suffix) return null;

    const finish = handle.slice(0, -suffix.length).replace(/-/g, ' ').trim();
    if (!finish) return null;

    return { handle, finish };
  }

  function getMatchingInput(card, finishData) {
    const inputs = Array.from(card.querySelectorAll('.js-option[value][data-variant-id]'));
    if (!inputs.length) return null;

    if (finishData.handle.startsWith('satin-nickel-')) {
      const matchers = [
        (value) => value === 'satin nickel',
        (value) => value.includes('brushed satin nickel'),
        (value) => value.includes('brushed nickel'),
        (value) => value.includes('nickel')
          && !value.includes('polished nickel')
          && !value.includes('antique nickel')
          && !value.includes('bright nickel')
          && !value.includes('black nickel')
      ];

      for (const matcher of matchers) {
        const input = inputs.find((item) => matcher(normalize(item.value)));
        if (input) return input;
      }
      return null;
    }

    const exact = inputs.find((input) => normalize(input.value) === finishData.finish);
    if (exact) return exact;

    return inputs.find((input) => normalize(input.value).includes(finishData.finish)) || null;
  }

  function updateProductLinks(card, input) {
    const variantId = input.dataset.variantId;
    if (!variantId) return;

    card.querySelectorAll('.js-prod-link').forEach((link) => {
      try {
        const url = new URL(link.getAttribute('href') || link.href, window.location.origin);
        url.searchParams.set('variant', variantId);
        link.href = `${url.pathname}${url.search}${url.hash}`;
      } catch (error) {
        // Keep the existing URL if parsing fails.
      }
    });
  }

  function updateCardImage(card, input) {
    const mediaId = input.dataset.mediaId;
    if (!mediaId) return;

    const images = Array.from(card.querySelectorAll('.card__main-image[data-media-id]'));
    const target = images.find((image) => String(image.dataset.mediaId) === String(mediaId));
    if (!target) return;

    images.forEach((image) => {
      image.classList.remove('is-active');
      image.hidden = true;
    });

    target.hidden = false;
    target.classList.add('is-active');
  }

  function updateCardInventory(card, input) {
    const variantId = input.dataset.variantId;
    if (!variantId) return;

    card.querySelectorAll('.js-card-inventory-item[data-variant-id]').forEach((item) => {
      item.hidden = String(item.dataset.variantId) !== String(variantId);
    });
  }

  function applyFinishToCard(card, finishData) {
    if (card.dataset.fdhFinishCollection === finishData.handle) return;

    const input = getMatchingInput(card, finishData);
    if (!input) {
      card.dataset.fdhFinishCollection = finishData.handle;
      return;
    }

    input.checked = true;

    // Use the theme's normal swatch-change pathway so variant price and any native card state update too.
    input.dispatchEvent(new Event('change', { bubbles: true }));

    // Reinforce the finish-specific display/link state without changing product media assignments.
    updateCardImage(card, input);
    updateProductLinks(card, input);
    updateCardInventory(card, input);

    card.dataset.fdhFinishCollection = finishData.handle;
  }

  function applyFinishCollectionCards() {
    const finishData = getFinishData();
    if (!finishData) return;

    document.querySelectorAll('#filter-results product-card').forEach((card) => {
      applyFinishToCard(card, finishData);
    });
  }

  function initFinishCollectionCards() {
    const finishData = getFinishData();
    if (!finishData) return;

    applyFinishCollectionCards();

    const results = document.getElementById('filter-results');
    if (!results || results.dataset.fdhFinishObserver === 'true') return;

    results.dataset.fdhFinishObserver = 'true';
    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(applyFinishCollectionCards);
    });
    observer.observe(results, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFinishCollectionCards, { once: true });
  } else {
    initFinishCollectionCards();
  }
})();
